import Pluralize from "pluralize";

export const pluralize = (str, count = null) => {
  return !!count ? Pluralize(str, count) : Pluralize(str);
};

export const singularize = (str) => {
  return Pluralize.singular(str)
}